import * as Colors from '@brightlayer-ui/colors';

export const Styles = {
    button: { textTransform: 'uppercase', borderRadius: '50px', width: '100%' },
    readOnlyField: { width: '425px' },
    errorIcon: { color: Colors.red[500] },
};
